import { render, staticRenderFns } from "./OutbreakDetail.vue?vue&type=template&id=221655be&"
import script from "./OutbreakDetail.vue?vue&type=script&lang=js&"
export * from "./OutbreakDetail.vue?vue&type=script&lang=js&"
import style0 from "./OutbreakDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports